import {Component, React} from '$src/handy'
import {Broadcast, Subscriber} from 'react-broadcast'
import {types, getSnapshot, onPatch} from 'mobx-state-tree'
import {Observer} from 'mobx-react'
import hoistNonReactStatics from 'hoist-non-react-statics'

export const FieldValuesStore = types
  .model('FormValues', {values: types.map(types.frozen)})
  .actions(self => ({
    setFieldValue(fieldName: string, value: any) {
      self.values.set(fieldName, value)
    },
  }))

type IValuesMstType = typeof FieldValuesStore.Type
export interface IValuesMst extends IValuesMstType {}

interface FormProps {
  valuesMst?: IValuesMst
  children: React.ReactNode
  initialValues?: object
  onSubmit: (snapshot: any) => void
  disabled?: boolean
}

const broadcastChannelName = 'formStuff'

export class Form extends Component<FormProps, {}> {
  _selfGeneratedValuesMst?: IValuesMst

  constructor(props: FormProps, ctx: any) {
    super(props, ctx)
    if (!props.valuesMst) {
      this._selfGeneratedValuesMst = FieldValuesStore.create({
        values: props.initialValues || {},
      })
    } else {
      this._selfGeneratedValuesMst = undefined
    }
  }

  getValuesMst(): IValuesMst {
    // @ts-ignore
    return this.props.valuesMst || this._selfGeneratedValuesMst
  }

  _onSubmit = (e: any) => {
    e.preventDefault()
    if (this.props.disabled) return
    this.props.onSubmit((getSnapshot(this.getValuesMst()) as any).values)
  }

  render() {
    const {props} = this

    return (
      <Broadcast
        channel={broadcastChannelName}
        value={{valuesMst: this.getValuesMst(), disabled: !!props.disabled}}
      >
        <form onSubmit={this._onSubmit}>{props.children}</form>
      </Broadcast>
    )
  }
}

export const Field = ({component$$$, ...rest}: any): any => {
  const C = component$$$
  return (
    <Subscriber channel={broadcastChannelName}>
      {({valuesMst, disabled}: {valuesMst: IValuesMst; disabled: boolean}) => {
        return (
          <Observer>
            {() => {
              const {name} = rest
              const set = (v: any) => {
                if (disabled) return
                valuesMst.setFieldValue(name, v)
              }
              let value = valuesMst.values.get(name)
              if (value === undefined) value = ''

              return <C onChange={set} value={value} {...rest} />
            }}
          </Observer>
        )
      }}
    </Subscriber>
  )
}

export const asField = (): any => (component: any): any => {
  const FinalComponent = (props: any) => (
    <Field component$$$={component} {...props} />
  )

  hoistNonReactStatics(FinalComponent, component)

  // @ts-ignore
  FinalComponent.displayName = `asField(${component.displayName ||
    component.name ||
    'Component'})`

  return FinalComponent
}



// WEBPACK FOOTER //
// ./src/common/forms.tsx